// extracted by mini-css-extract-plugin
export default {"masking_spinner_container":"masking-spinner_masking_spinner_container__OSMnx","masking_spinner_holder":"masking-spinner_masking_spinner_holder__9yi18"};